import { styled } from '@mui/system';
import { Button, Typography } from '@mui/material';

export const WidgetContainer = styled('div')({
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%'
});

export const Body = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden'
});

export const HeaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '1px solid #E1E4E7',
  padding: '0px 24px 12px'
});

export const HeaderText = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '24px',
  lineHeight: '28px',
  color: '#000000'
});

export const HeaderSubText = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.15px',
  color: '#000000',
  paddingTop: '12px'
});

export const Footer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'flex-end',
  borderTop: '1px solid #E1E4E7',
  padding: '16px 0px',
  marginTop: 'auto'
});

export const StyledButton = styled(Button)({
  width: '132px',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '24px'
});

export const CancelButton = styled(StyledButton)({
  backgroundColor: '#FBF0F0',
  color: '#621B16',
  '&:hover': {
    backgroundColor: '#FBF0F0',
    color: '#621B16'
  }
});